export default __webpack_public_path__ + "static/media/zoom-dynamic.72af572c.png";